import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip';
import { HelpCircle, Info } from 'lucide-react';

/**
 * Info tooltip component for adding explanations to metrics/labels
 * 
 * @param {string} content - Tooltip content
 * @param {string} variant - "help" | "info" (default: "help")
 * @param {string} side - "top" | "bottom" | "left" | "right" (default: "top")
 * @param {string} className - Additional CSS classes
 */
export const InfoTooltip = ({
  content,
  variant = 'help',
  side = 'top',
  className = '',
}) => {
  const Icon = variant === 'info' ? Info : HelpCircle;

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button 
            type="button"
            className={`inline-flex items-center justify-center h-4 w-4 text-neutral-400 hover:text-neutral-600 dark:hover:text-neutral-300 transition-colors cursor-help ${className}`}
          >
            <Icon className="h-3.5 w-3.5" strokeWidth={1.5} />
          </button>
        </TooltipTrigger>
        <TooltipContent 
          side={side} 
          className="max-w-xs text-xs bg-neutral-900 dark:bg-white text-white dark:text-neutral-900 px-3 py-2 rounded-lg shadow-lg"
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InfoTooltip;
